const CATEGORY_ORDER = { live: 0, upcoming: 1, past: 2 }

// DUB-184: a tournament whose every bracket has official results entered
// (status 'complete') is over, even if its end_date hasn't passed yet —
// don't keep showing it as "Live" until midnight.
export function allBracketsComplete(tournament) {
  const brackets = tournament?.brackets
  return Array.isArray(brackets)
    && brackets.length > 0
    && brackets.every(b => b?.status === 'complete')
}

export function getTournamentTimeStatus(tournament, now = new Date()) {
  if (allBracketsComplete(tournament)) return 'past'
  const start = tournament.startDate ? new Date(tournament.startDate) : null
  const end = tournament.endDate ? new Date(tournament.endDate) : null
  if (end && now > end) return 'past'
  if (start && now < start) return 'upcoming'
  return 'live'
}

// DUB-12: within each category, most-recent startDate first. The category
// order (Live → Upcoming → Past) applies only when no explicit time filter
// is active; with a filter, all rows share a category and we fall through
// to the date comparison.
export function compareTournaments(a, b, { tabValue = null, now = new Date() } = {}) {
  if (!tabValue) {
    const aCat = CATEGORY_ORDER[getTournamentTimeStatus(a, now)] ?? 3
    const bCat = CATEGORY_ORDER[getTournamentTimeStatus(b, now)] ?? 3
    if (aCat !== bCat) return aCat - bCat
  }

  const aDate = a.startDate ? new Date(a.startDate) : null
  const bDate = b.startDate ? new Date(b.startDate) : null
  if (!aDate) return 1
  if (!bDate) return -1
  return bDate - aDate
}
